$(function () {
	'use strict';

	var Tooltip = kendo.ui.Tooltip,
		tooltipShow = Tooltip.fn._show,
		tooltipControl;

	Tooltip.fn._show = function (target) {
		var tooltipFor = target.attr('tooltip-for'),
			tooltipTarget = target;
		if (tooltipFor) {
			if (tooltipFor === 'parent') {
				tooltipTarget = target.parent();
			} else {
				tooltipTarget = $('#' + tooltipFor);
			}
			tooltipTarget.attr('data-tooltip', target.attr('data-tooltip'));
		}
		tooltipShow.call(this, tooltipTarget);
	}

	function initTooltip() {
		tooltipControl && tooltipControl.destroy();
		tooltipControl = $('[data-tooltip]').kendoTooltip({
			autoHide: false,
			position: "top",
			showOn: 'focus tooltipFocus',
			content: function (e) {
				var target = e.target; // the element for which the tooltip is shown
				return target.attr('data-tooltip'); // set the element text as content of the tooltip
			}
		}).data('kendoTooltip');
	}

	$(document).ready(function () {
		initTooltip();
		$(document).on('blur tooltipBlur', '[data-tooltip]', function () {
			tooltipControl && tooltipControl.hide();
		});
	});

	ko.bindingHandlers.tooltip = {
		update: function (element, valueAccessor) {
		    ko.bindingHandlers.attr.update(element, function () { return { 'data-tooltip': valueAccessor() }; });
		    initTooltip();
		}
	};

});